import { NgModule } from '@angular/core';
import { AgreementEffects } from '@bca-agreement/store/agreement.effects';
import { CompanyDataEffects } from '@bca-company-data/store/company-data.effects';
import { ComposeEffects } from '@bca-compose/store/compose.effects';
import { ConfirmationEffects } from '@bca-confirmation/store/confirmation.effects';
import { ReceiptEffects } from '@bca-receipt/store/receipt.effects';
import { IStorageErrorEvent } from '@bca-store/models/storage-error';
import { IRootState, reducers } from '@bca-store/store.reducers';
import { UserDataEffects } from '@bca-user-data/store/user-data.effects';
import { AppEffects } from '@bca-store/app.effects';
import { environment } from '@environments/environment';
import { storageSync } from '@larscom/ngrx-store-storagesync';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, StoreModule as NgRxStoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { storeFreeze } from 'ngrx-store-freeze';

export function storageSyncReducer(reducer: ActionReducer<IRootState>): ActionReducer<IRootState> {
  return storageSync<IRootState>({
    features: [
      { stateKey: 'receipt' },
      { stateKey: 'app', excludeKeys: ['lastMessage', 'dialogStatus'] },
      {
        stateKey: 'compose',
        excludeKeys: ['products', 'productsLoading', 'stationsLoading', 'routeLoading']
      },
      {
        stateKey: 'userData',
        excludeKeys: ['middleNames', 'addressLoading', 'middleNamesLoading', 'imageUploading']
      },
      { stateKey: 'companyData', excludeKeys: ['companyLoading', 'companyFetching'] },
      {
        stateKey: 'agreement',
        excludeKeys: ['issuers', 'agreementPreviewLoading', 'agreementPreviewAsBase64']
      },
      { stateKey: 'confirmation', excludeKeys: ['startPaymentLoading', 'statusPaymentLoading'] }
    ],
    storageError: error => {
      const event = document.createEvent('Event') as IStorageErrorEvent;
      event.error = error;
      event.initEvent('storageError', true, true);
      window.dispatchEvent(event);
    },
    storageKeySerializer: (key: string) => `${environment.storageKeySerializer}_${key}`,
    storage: window.sessionStorage
  })(reducer);
}

const devtools = environment.production
  ? []
  : [
      StoreDevtoolsModule.instrument({
        name: environment.name,
        maxAge: 40
      , connectInZone: true})
    ];

const metaReducers = environment.production
  ? [storageSyncReducer]
  : [storeFreeze, storageSyncReducer];

@NgModule({
  imports: [
    NgRxStoreModule.forRoot(reducers, { metaReducers }),
    ...devtools,
    EffectsModule.forRoot([
      AppEffects,
      ComposeEffects,
      UserDataEffects,
      ReceiptEffects,
      CompanyDataEffects,
      AgreementEffects,
      ConfirmationEffects
    ])
  ],
  exports: [NgRxStoreModule]
})
export class StoreModule {}
